module.exports = __webpack_public_path__ + "static/media/cc_icon-mcjapan.b2c5dd6e.svg";